import type React from 'react';
import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { Text, TextType } from 'ui-components/components/text';
import { messages } from './messages';
import style from '../../../style.module.less';

interface CustomsHelpMessageProps {
  helpMessage: MessageDescriptor;
}

export const CustomsHelpMessage: React.FC<CustomsHelpMessageProps> = ({ helpMessage }) => {
  return (
    <div className={style['no-ids-instructions']}>
      <Text
        textType={TextType.Caption}
        value={
          <FormattedMessage
            {...helpMessage}
            values={{
              internationalSettingsLink: (
                <Link to='/settings/international'>
                  <FormattedMessage {...messages.internationalSettingsPage} />
                </Link>
              ),
            }}
          />
        }
      />
    </div>
  );
};
